import { render } from "./pos-holidays.vue?vue&type=template&id=0029954f"
import script from "./pos-holidays.vue?vue&type=script&lang=js"
export * from "./pos-holidays.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__